"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AgentCardInfo = _interopRequireDefault(require("./AgentCardInfo"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'AgentCard',
  props: {
    profile: Object,
    user: Object,
    loadingUser: Boolean,
    loadingProfile: Boolean
  },
  components: {
    AgentCardInfo: _AgentCardInfo.default
  }
};
exports.default = _default;